import { ReactElement, useState, useCallback } from 'react';
import { Stack, Typography, Button } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus as AddIcon } from '@fortawesome/free-solid-svg-icons';

import { useRequest, useToggle } from '~hooks/index';
import { getAdmingBillingListBillings } from '~services/admin/billingList/billing';
import { AdminBillingListBillingBase } from '~services/admin/billingList/billing/types';

import { ConfigBillingListBillingsProps } from './types';
import ConfigBillingListBillingsTable from './Table';
import DialogBillingListBillingForm from '../DialogBillingListBillingForm';

const ConfigBillingListBillings = ({
  billingListId,
  defaultBillingListCode,
}: ConfigBillingListBillingsProps): ReactElement => {
  const [billingsData, setBillingsData] = useState<
    AdminBillingListBillingBase[]
  >([]);

  const [, loadingBillings, , reloadBillingsData] = useRequest({
    request: getAdmingBillingListBillings,
    payload: billingListId,
    withPostSuccess: (response) => {
      const currentBillingsData = response.data
        ?.data as AdminBillingListBillingBase[];

      setBillingsData(currentBillingsData);
    },
  });

  const reloadData = useCallback(() => {
    reloadBillingsData(billingListId);
  }, [reloadBillingsData, billingListId]);

  const [openAddBillingDialog, toggleOpenAddBillingDialog] = useToggle(false);

  const onSuccessAddBilling = useCallback(() => {
    toggleOpenAddBillingDialog(false);

    reloadData();
  }, [reloadData, toggleOpenAddBillingDialog]);

  return (
    <Stack spacing={2} height="100%">
      <Stack spacing={2} direction="row" alignItems="center">
        <Typography component="h6" fontWeight="bold">
          Tarifas asociadas
        </Typography>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<FontAwesomeIcon icon={AddIcon} />}
          onClick={() => toggleOpenAddBillingDialog(true)}
        >
          Agregar
        </Button>
      </Stack>

      <ConfigBillingListBillingsTable
        billingListId={billingListId}
        defaultBillingListCode={defaultBillingListCode}
        loading={loadingBillings}
        data={billingsData}
        reloadData={reloadData}
      />

      {openAddBillingDialog && (
        <DialogBillingListBillingForm
          open={openAddBillingDialog}
          onClose={() => toggleOpenAddBillingDialog(false)}
          billingListId={billingListId}
          defaultBillingListCode={defaultBillingListCode}
          onSuccessSubmit={onSuccessAddBilling}
        />
      )}
    </Stack>
  );
};

export default ConfigBillingListBillings;
